<template>
  <div class="szw-widget-base-banner">
    <span v-if="status === 'loading'" class="szw-bg-section-static szw-rounded szw-h-5 szw-w-full szw-animate-pulse" :style="{ maxWidth: 'calc(100% - 28px - 16px)' }"></span>

    <template v-if="status === 'success'">
      <sprite sprite-id="venue" :color="'var(--szw-text-icon-primary)'" class="szw-w-5" />
      <span class="szw-text-xs szw-truncate" :style="{ maxWidth: 'calc(100% - 28px - 16px)' }">
        {{ props.venueDetails.name || '' }}, {{ props.venueDetails.city || '' }},
        {{ props.venueDetails.countryCode || '' }}
      </span>
    </template>
  </div>
</template>

<script setup>
import Sprite from '@/__core__/components/sprite/Sprite.vue'
import { inject } from 'vue'

const props = defineProps({
  venueDetails: {
    type: Object,
    default: () => ({
      name: '',
      city: '',
      countryCode: ''
    })
  }
})

const status = inject('status')
</script>
